import React from 'react';
import { Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { Evento } from './Evento';
import EventoForm from './EventoForm';

const EventoAltaPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSubmit = async (eventoData: Evento) => {
    try {
      const payload = {
        ...eventoData,
        fechaInicio: eventoData.fechaInicio?.toISOString(),
        fechaFin: eventoData.fechaFin?.toISOString(),
        precio: typeof eventoData.precio === 'number' ? eventoData.precio : undefined
      };

      await axios.post(`${config.backendUrl}/api/Eventos`, payload);
      navigate('/eventos');
    } catch (error) {
      console.error('Error al crear el evento:', error);
      alert('Ocurrió un error al crear el evento');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Crear Nuevo Evento
      </Typography>
      <EventoForm onSubmit={handleSubmit} />
    </Container>
  );
};

export default EventoAltaPage;